var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.734,
    height: 32.979,
    viewBox: "0 0 24.734 32.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#525252;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M76.367,0A12.381,12.381,0,0,0,64,12.367c0,9.124,11.41,19.968,11.9,20.425a.688.688,0,0,0,.942,0c.486-.458,11.9-11.3,11.9-20.425A12.381,12.381,0,0,0,76.367,0Zm0,19.238a6.871,6.871,0,1,1,6.871-6.871A6.879,6.879,0,0,1,76.367,19.238Z",
    transform: "translate(-64)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1906ef9b15554150e7b2ee82210094a5.svg";
export { ForwardRef as ReactComponent };